import { defaultIconProps, IconProps } from './IconProps';

export const IconOpenbmb: import('react').FC<IconProps> = ({ size, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <path d="M4.00065 3.99983H16.1911V9.58713H4.00065V3.99983Z" fill="#315EFE" />
    <path d="M22.7943 10.603H10.6038V16.1903H22.7943V10.603Z" fill="#315EFE" />
    <path d="M4.00065 17.2062H16.1911V22.7935H4.00065V17.2062Z" fill="#315EFE" />
    <path d="M22.7943 23.8094H10.6038V29.3967H22.7943V23.8094Z" fill="#315EFE" />
    <path d="M16.1911 30.4125H4.00065V35.9998H16.1911V30.4125Z" fill="#315EFE" />
    <path d="M29.3975 30.4125H17.207V35.9998H29.3975V30.4125Z" fill="#00D3ED" />
    <path d="M23.8102 23.8094H36.0007V29.3967H23.8102V23.8094Z" fill="#00D3ED" />
    <path d="M29.3975 17.2062H17.207V22.7935H29.3975V17.2062Z" fill="#00D3ED" />
    <path d="M23.8102 10.603H36.0007V16.1903H23.8102V10.603Z" fill="#00D3ED" />
    <path d="M29.3975 3.99983H17.207V9.58713H29.3975V3.99983Z" fill="#00D3ED" />
  </svg>
);

IconOpenbmb.defaultProps = defaultIconProps;
